/** Tiny DOM helpers shared across the client island. */

export function $<T extends Element = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T | null {
  return root.querySelector<T>(selector);
}

export function $$<T extends Element = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}

export function on<K extends keyof HTMLElementEventMap>(
  el: Element | Document | Window | null,
  event: K | string,
  handler: (ev: Event) => void,
  options?: AddEventListenerOptions,
): void {
  el?.addEventListener(event, handler as EventListener, options);
}

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Partial<Record<string, string>> = {},
  children: Array<Node | string> = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(props)) {
    if (value == null) continue;
    if (key === "class") node.className = value;
    else node.setAttribute(key, value);
  }
  for (const child of children) node.append(child);
  return node;
}

/** Briefly swap a button's label/icon to confirm an action. */
export function flashButton(button: HTMLElement | null, message: string, ms = 1600): void {
  if (!button) return;
  const label = button.querySelector("span");
  if (!label) return;
  const original = label.textContent;
  label.textContent = message;
  button.classList.add("flash");
  window.setTimeout(() => {
    label.textContent = original;
    button.classList.remove("flash");
  }, ms);
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
